<template>
  <div v-if="data">
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <page-title
      >Shipping Applicatiion Details - {{ data.reference_number }}</page-title
    >
    <keep-alive>
      <shipper-detail :data="data"></shipper-detail>
    </keep-alive>
  </div>
</template>

<script>
import ShipperDetail from "../components/ShipperDetail.vue";
import { mapGetters } from "vuex";
export default {
  name: "shipping-application-details",
  components: { ShipperDetail },
  data() {
    return {
      data: null,
      isPaginated: true,
      isPaginationSimple: false,
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 5,
      updateStatus: true,
      isLoading: true
    };
  },
  computed: {
    ...mapGetters({
      getShipmentByID: "getShipmentByID"
    })
  },
  mounted() {
    this.data = this.getShipmentByID(this.$route.params.id)[0];
    this.isLoading = false;
  }
};
</script>
